<template>
    <main class="main with-sidebar">
        <div class="container">
            <div v-show="visible">

                <div class="row">
                    <div class="col-lg-12">

                        <div class="page-header">
                            <span :class="{'button-full': true, 'loading': loading}" @click="validateForm()">{{ $t('button.save') }}</span>
                        </div>

                    </div>
                </div>

                <div class="row">

                    <div class="col-lg-5 col-md-12">

                        <h2>
                            {{ $t('label.about') }}
                        </h2>

                        <form class="form" @submit.prevent>

                            <div class="row">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.name')"
                                            :type="'text'"
                                            v-model="organization.name"
                                            validate="required"
                                    >
                                    </input-widget>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                  <label>{{ $t('label.country') }}</label>
                                    <div class="select">
                                        <select v-model="organization.country" name="country">
                                            <option v-for="country in countries" :value="country.code">{{ country.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <label>{{ $t('label.currency') }}</label>
                                    <div class="select">
                                        <select v-model="organization.currency" name="currency">
                                            <option value="" selected="selected">{{ $t('label.chooseCurrency') }}</option>
                                            <option v-for="currency in currencies" :value="currency">{{ $t('currencies.' + currency) }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.email')"
                                            :type="'email'"
                                            v-model="organization.email"
                                            validate="required|email"
                                    >
                                    </input-widget>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.businessPhone')"
                                            :type="'text'"
                                            v-model="organization.phone"
                                            validate="required"
                                    >
                                    </input-widget>
                                </div>
                            </div>

                        </form>

                    </div>

                    <div class="col-lg-6 col-lg-offset-1 col-md-12 col-md-offset-0">

                        <h2 class="mobile-margin-top-30">
                            {{ $t('label.businessHours') }}
                        </h2>

                        <form class="form" @submit.prevent>

                            <div class="row middle" v-for="(day, index) in organization.week_days">
                                <div class="col-lg-4">
                                    <label class="checkbox-label">
                                        <span class="checkbox-label-marker">
                                            <input type="checkbox" v-model="day.on"  />
                                            <span class="checkbox-label-flag"></span>
                                        </span>
                                        <span class="checkbox-label-text">
                                            {{ $t('days.' + index ) }}
                                        </span>
                                    </label>
                                </div>
                                <div class="col-lg-4 col-xs-6">
                                    <div :class="{ 'select': true, 'disabled': !day.on }">
                                        <select name="day.start" id="start" v-model="day.start" :disabled="!day.on">
                                            <option :value="hour" v-for="hour in (0, 23)">{{ hour }}:00</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-xs-6">
                                    <div :class="{ 'select': true, 'disabled': !day.on }">
                                        <select name="day.end" id="end" v-model="day.end" :disabled="!day.on">
                                            <option :value="hour" v-for="hour in (0, 23)">{{ hour }}:00</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>

                </div>
            </div>
        </div>
    </main>
</template>

<script>
  import auth from '@/auth'
  import inputWidget from '@/components/widgets/InputWidget'

  export default {
    name: 'Profile',
    components: {
      inputWidget
    },
    created () {
      this.getOrganization()
      this.$api.get('/v1/countries').then(response => {
        this.countries = response.data
      })
    },
    data () {
      return {
        countries: [],
        visible: false,
        loading: false,
        organization: {},
        currencies: auth.getCurrencies()
      }
    },
    methods: {
      getOrganization () {
        this.$api.get('/v1/organizations/profile').then(response => {
          this.organization = response.data.data
          this.visible = true
        }).catch(() => {
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
        })
      },
      validateForm () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      save () {
        this.loading = true
        let formData = this.createFormData()
        this.$api.post('/v1/organizations/profile', formData).then(response => {
          let user = auth.getUser()
          if (user.personal.organization.currency !== response.data.data.currency) {
            user.personal.organization.currency = response.data.data.currency
            window.localStorage.setItem('user', JSON.stringify(user))
            this.$router.go(this.$route.path)
          }
          this.loading = false
          this.$events.fire('message-open', {
            type: 'success',
            message: this.$t('message.saveSuccess')
          })
        }).catch(() => {
          this.loading = false
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.saveFailed')
          })
        })
      },
      createFormData () {
        let data = []
        data['name'] = this.organization.name
        data['email'] = this.organization.email
        data['phone'] = this.organization.phone
        data['country'] = this.organization.country
        data['currency'] = this.organization.currency
        data['image'] = this.organization.image
        for (let weekDay in this.organization.week_days) {
          data['week_days[' + weekDay + '][id]'] = this.organization.week_days[weekDay].id
          data['week_days[' + weekDay + '][date]'] = this.organization.week_days[weekDay].date
          data['week_days[' + weekDay + '][day_of_week]'] = parseInt(this.organization.week_days[weekDay].day_of_week)
          data['week_days[' + weekDay + '][end]'] = parseInt(this.organization.week_days[weekDay].end)
          data['week_days[' + weekDay + '][start]'] = parseInt(this.organization.week_days[weekDay].start)
          data['week_days[' + weekDay + '][on]'] = this.organization.week_days[weekDay].on ? 1 : 0
        }
        let formData = new FormData()

        for (let entry in data) {
          if (data[entry] === null || typeof data[entry] === 'undefined') {
            continue
          }
          formData.append(entry, data[entry])
        }

        return formData
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Profile.vue